<template>
    <div class="dp_flex">
        <sui-input-label :label="computedLabel" :title="computedLabel" />
    </div>
</template>
<script>
export default {
    name: "CmpDeptName",
    props:{
        pageId: {
            type: String,
            default: "",
        },
        displayLanguageId: {
            type: String,
            default: '',
        },
        departmentName: {
            type: String,
            default: '',
        },
        departmentEnglishName: {
            type: String,
            default: '',
        },
    },
    mounted(){
    },
    computed: {
        computedLabel(){
            return this.sessionLangId == this.displayLanguageId ? this.departmentName: this.departmentEnglishName;
        },
    },
    data() {
        return {
            sessionLangId : this.$store.getters.userInfo.langId,
        }
    },
    methods: {
    }
}
</script>
<style scoped>

</style>